// @core/api/endpoints/apikey/update_api_key_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyPolicyResponse,
  UpdateAPIKeyPolicyRequest,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Update API key policy
 * Updates an existing API key policy.
 */
export async function UpdateAPIKeyPolicy(
  policy_id: string,
  data: UpdateAPIKeyPolicyRequest,
  options?: RequestOptions
): Promise<APIKeyPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-key-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<APIKeyPolicyResponse>(requestPath, data, requestOptions);
}
